module.exports = __webpack_public_path__ + "static/5-edb6acef9dd5bdf5fc73eae0d100108c.jpg";